import React from 'react';

import { IconButton } from 'components';
import Modal from 'components/Modal';
import { ButtonV3 } from 'components/ComponentV2';
import { CompanyAttributes } from 'lib/models/company';
import { OnboardSteps } from '../OnboardSteps/OnboardSteps.component';

import styles from './InviteSponsorModal.module.scss';

interface InviteSponsorModalProps {
  open: boolean;
  companyData?: CompanyAttributes;
  copyInvitationLink: () => void;
  onClose: () => void;
}

export const InviteSponsorModal: React.FC<InviteSponsorModalProps> = (
  props: InviteSponsorModalProps
) => {
  const { open, companyData, copyInvitationLink, onClose } = props;

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentClassName={styles.InviteSponsorModal}
    >
      <div className={styles.InviteSponsorModalHeader}>
        <IconButton iconName="close" size="small" onClick={() => onClose()} />
      </div>

      <div className={styles.InviteSponsorModalContent}>
        <p className={styles.emoji}>🙄</p>
        <p className={styles.message}>
          {companyData?.name} cannot be messaged through Huzzle. Use your
          invitation link to invite them manually.
        </p>
        <ButtonV3
          size="large"
          startIcon="icon_link"
          onClick={copyInvitationLink}
        >
          Copy invitation link
        </ButtonV3>
        <OnboardSteps className={styles.infoBox} />
      </div>
    </Modal>
  );
};
